import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-message",
  "use": "icon-message-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-message\"><defs><style>#icon-message .cls-1{fill:none;}</style></defs><title> </title><g id=\"icon-message_无色底\"><rect id=\"icon-message__矩形_\" data-name=\"&lt;矩形&gt;\" class=\"cls-1\" width=\"16\" height=\"16\" /></g><g id=\"icon-message_图层_1\" data-name=\"图层 1\"><path d=\"M14.06,11,13,9V6A5,5,0,0,0,9,1.1V1A1,1,0,0,0,7,1v.1A5,5,0,0,0,3,6V9L1.94,11a.94.94,0,0,0-.94.94v.13a.94.94,0,0,0,.94.94H14.06a.94.94,0,0,0,.94-.94v-.13A.94.94,0,0,0,14.06,11Z\" /><path d=\"M8,16a4,4,0,0,0,3.45-2H4.55A4,4,0,0,0,8,16Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/message.svg
// module id = G2zY
// module chunks = 35